import { render, staticRenderFns } from "./AIChatInput.vue?vue&type=template&id=02bc6bad&scoped=true&"
import script from "./AIChatInput.vue?vue&type=script&lang=js&"
export * from "./AIChatInput.vue?vue&type=script&lang=js&"
import style0 from "./AIChatInput.vue?vue&type=style&index=0&id=02bc6bad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc6bad",
  null
  
)

export default component.exports